import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { useStyles } from './styles';

export interface EmptyPlaceholderProps {
  placeholder?: string;
}

export default function EmptyPlaceholder(props: EmptyPlaceholderProps) {
  const { placeholder = 'The table is empty' } = props;
  const classes = useStyles();

  return (
    <Box className={classes.wrapper}>
      <Typography variant="body1" className={classes.placeholder}>
        {placeholder}
      </Typography>
    </Box>
  );
}
